import { createTheme, Theme } from '@mui/material/styles';

/** Night only: an esoteric app is read by candlelight. Gold on a violet black, parchment text. */
export const palette = {
    primary: { main: '#d4af6a', contrastText: '#120a1f' },
    secondary: { main: '#9d7bd8', contrastText: '#120a1f' },
    background: { default: '#0b0713', paper: '#150e24' },
    text: { primary: '#efe6d2', secondary: '#b9a9c9' },
};

export const getTheme = (): Theme => {
    let meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'theme-color');
        document.head.appendChild(meta);
    }
    meta.setAttribute('content', palette.background.default);

    const heading = '"Cinzel", "Cormorant Garamond", Georgia, serif';
    return createTheme({
        palette: { mode: 'dark', ...palette },
        shape: { borderRadius: 10 },
        typography: {
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontSize: 16,
            body1: { fontSize: '1.15rem', lineHeight: 1.55 },
            body2: { fontSize: '1.05rem', lineHeight: 1.5 },
            button: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
            },
            h1: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.2em',
            },
            h2: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.12em',
            },
            h3: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.1em',
            },
            h4: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.1em',
            },
            h5: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.1em',
            },
            h6: {
                fontFamily: heading,
                fontWeight: 600,
                letterSpacing: '0.1em',
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    html: { width: '100%', height: '100%', overflow: 'hidden' },
                    body: {
                        width: '100%',
                        height: '100%',
                        margin: 0,
                        overflow: 'hidden',
                        backgroundColor: palette.background.default,
                    },
                    // Sized to the viewport, not to <body>: the AdSense script forces `height: auto !important`.
                    '#root': {
                        width: '100%',
                        height: '100vh',
                        '@supports (height: 100dvh)': { height: '100dvh' },
                        display: 'flex',
                        flexDirection: 'column',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: { minHeight: 48, borderRadius: 2 },
                    contained: {
                        background:
                            'linear-gradient(180deg, #e4c37e 0%, #b8913f 100%)',
                        boxShadow: '0 0 18px rgba(212,175,106,.35)',
                    },
                    outlined: { borderColor: 'rgba(212,175,106,.55)' },
                },
            },
            MuiIconButton: {
                styleOverrides: { root: { minWidth: 48, minHeight: 48 } },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: 'none',
                        border: '1px solid rgba(212,175,106,.22)',
                    },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paper: { backgroundColor: '#150e24' },
                },
            },
        },
    });
};

export default getTheme;
